<template>
    <div>
        <notification-container :notifications="notifications" />
        <tag
            :class="classes"
            @click="hitApi"
            :disabled="internalDisabled"
            :is="tag"
        >
            <i v-if="iconClass" :class="iconClass"></i> {{ text }}
        </tag>
    </div>
</template>

<script>
import Tag from "../Tag.vue";
import NotificationContainer from "../../Common/NotificationContainer.vue";
import notificationsMixin from "../../../mixins/notifications.js";

export default {
    name: 'ApiPostButton',

    components: {
        Tag,
        NotificationContainer,
    },

    mixins: [notificationsMixin],

    props: {
        classes: {
            type: String,
            required: false,
        },
        config: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        confirm: {
            type: String,
            required: false,
        },
        disabled: {
            default: false,
            required: false,
            type: Boolean,
        },
        endPoint: {
            type: String,
            required: true,
        },
        iconClass: {
            required: false,
            type: String,
        },
        method: {
            type: String,
            required: false,
            default: `post`,
        },
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        tag: {
            type: String,
            required: false,
            default: `button`,
        },
        text: {
            type: String,
            required: true,
        },
        isDisableRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
        authenticationType: {
            type: String,
            default: 'session',
            required: false,
            validator: value => ['jwt', 'session'].includes(value),
        },
    },

    data() {
        return {
            internalDisabled: this.disabled,
        }
    },

    methods: {
        hitApi() {
            if (this.confirm && !confirm(this.confirm)) {
                return;
            }
            this.toggleDisabled();

            const makeRequest = () => {
                let param2 = this.method === 'delete' ? this.config : this.params;
                let param3 = this.method === 'delete' ? this.params : this.config;

                if (this.authenticationType === 'jwt') {
                    return this.$root.makeApiRequest((jwtToken) => {
                        const authHeaders = { 'Authorization': jwtToken, 'Accept': 'application/json' };
                        if (this.method === 'delete') {
                            return axios.delete(this.endPoint, { ...param2, headers: authHeaders });
                        }
                        return axios[this.method](this.endPoint, param2, {
                            ...param3,
                            headers: authHeaders,
                        });
                    });
                }

                return axios[this.method](this.endPoint, param2, param3);
            };

            makeRequest()
                .then(response => {
                    if (Object.hasOwnProperty.call(response.data, 'code') && ![200, 202].includes(response.data.code)) {
                        if (response.data.code === 403) {
                            this.showAlertMessage(`You do not have permission to perform this action. Please switch to the correct account.`, 'error');
                        } else {
                            this.showAlertMessage('Something went wrong. Please contact support.', 'error');
                        }
                        this.returnError(response.message);
                        return;
                    }
                    this.$emit(`response`, response);
                    if (!this.isDisableRequired) {
                        this.toggleDisabled();
                    }
                })
                .catch(error => this.returnError(error));
        },
        returnError(error) {
            this.$emit(`error`, error);
            this.toggleDisabled();
        },
        toggleDisabled() {
            Object.assign(this, {internalDisabled: !this.internalDisabled});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/ApiPostButton.vue